import * as Cookies from 'js-cookie';

export default {
  el: null,
  closeButton: null,
  backboard: null,
  selector: '#theme-lightbox',
  mods: {
    visible: 'lightbox--visible',
  },
  hashToken: null,
  method: null,
  delay: null,
  hiatus: null,
  openEvent: null,
  openSelector: null,
  closeEvent: null,
  closeSelector: null,
  hiatusCookieName: 'lightboxHiatusFlag',
  wasSeen: false,

  _setupTimedLightbox() {
    // open
    if ( this.delay >= 0 ) {
      window.setTimeout( function () {
        this.open()
      }.bind(this), this.delay*1000);
    }
    // set no-show cookie on close...
    // ideally we would use an emitter, but i don't have time to set that up ATM
    // see below in close()
  },

  _setupActionLightbox() {

    if ( this.openSelector ) {
      const openTriggers = document.querySelectorAll(this.openSelector);
      [].forEach.call(openTriggers, trigger => {
        trigger.addEventListener(this.openEvent, e => {
          this.open(true);
        });
      });
    }

    if ( this.closeSelector ) {
      const closeTriggers = document.querySelectorAll(this.closeSelector);
      [].forEach.call(closeTriggers, trigger => {
        trigger.addEventListener(this.closeEvent, e => {
          this.close();
        });
      });
    }
  },

  _bindEvents() {
    // without cookies enabled, popup would show on every page
    if ( this.method == 'time' && window.Modernizr.cookies ) {
      this._setupTimedLightbox();
    } else if ( this.method == 'action' ) {
      this._setupActionLightbox();
    }

    this.closeButton.addEventListener('click', () => this.close());
    this.backboard.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if ( e.key == 'Escape' ) this.close();
    });
  },

  init() {
    this.el            = document.querySelector(this.selector);
    if ( !this.el ) return;
    this.closeButton   = document.querySelector(`${this.selector} .lightbox__x`);
    this.backboard     = document.querySelector(`${this.selector} .lightbox__backboard`);
    this.hashToken     = this.el.dataset.hashToken;
    this.method        = this.el.dataset.openTrigger;
    this.delay         = parseInt(this.el.dataset.delay, 10);
    this.hiatus        = parseInt(this.el.dataset.hiatus, 10);
    this.openEvent     = this.el.dataset.openEvent;
    this.openSelector  = this.el.dataset.openSelector;
    this.closeEvent    = this.el.dataset.closeEvent;
    this.closeSelector = this.el.dataset.closeSelector;
    this._bindEvents();
  },

  open(force) {
    if ( force === undefined ) force = !this.isOnHiatus();

    if ( force ) {
      this.el.classList.add(this.mods.visible);
      this.wasSeen = true;
    }
  },

  close() {
    this.el.classList.remove(this.mods.visible);

    // ENHANCEMENT: use an event emitter
    if ( this.method == 'time' && this.wasSeen ) {
      Cookies.set(this.hiatusCookieName, this.hashToken, { expires: this.hiatus });
    }
  },

  isOnHiatus() {
    return Cookies.get(this.hiatusCookieName) == this.hashToken;
  },
}

